import Papa = require('papaparse');
import {parse} from 'date-fns';

export interface IntermediateEntry {
    date: string;
    revenue: number;
    cost: number;
    costDetails: {
        staff: number;
        rent: number;
        other: number;
    };
    result: number;
}

export interface Month {
    date: Date;
    revenue: number;
    cost: number;
    costDetails: {
        staff: number;
        rent: number;
        other: number;
    };
    result: number;
}

function reserve(dates: string[], result: {[p: string]: IntermediateEntry}) {
    dates.forEach((date) => {
        if (result[date] === undefined) {
            result[date] = {
                date: date,
                revenue: 0,
                cost: 0,
                costDetails: {
                    staff: 0,
                    rent: 0,
                    other: 0,
                },
                result: 0,
            };
        }
    });
}

function extract(
    data: Array<unknown>,
    result: {[date: string]: IntermediateEntry},
    categoryName: string,
    callback: (date: string, value: number) => void,
) {
    data.forEach((row: any) => {
        const [_, ...dates] = Object.keys(row as any);
        const [category] = Object.values(row);
        if (category === categoryName) {
            reserve(dates, result);

            dates.forEach((date) => {
                callback(date, parseFloat(row[date].replace(',', '')));
            });
        }
    });
}

function translateDate(date: string): string {
    return date.toLowerCase().replace('mrt', 'mar').replace('mei', 'may').replace('okt', 'oct');
}

export const importCsv = (csv: string): Month[] => {
    const parseResult = Papa.parse(csv, {
        header: true,
    });

    const data: Array<unknown> = parseResult.data;
    const result: {[date: string]: IntermediateEntry} = {};

    extract(data, result, 'Totaal omzet', (date, value) => {
        result[date].revenue = value;
    });

    extract(data, result, 'Totaal kosten', (date, value) => {
        result[date].cost = value;
    });

    extract(data, result, 'Nettoresultaat', (date, value) => {
        result[date].result = value;
    });

    extract(data, result, '-- Huisvestingskosten', (date, value) => {
        result[date].costDetails.rent = value;
    });

    extract(data, result, '-- Personeel', (date, value) => {
        result[date].costDetails.staff = value;
    });

    return Object.values(result)
        .map((item) => {
            item.costDetails.other = item.cost - (item.costDetails.rent + item.costDetails.staff);
            return item;
        })
        .map((item) => {
            return {
                ...item,
                date: parse(translateDate(item.date), 'MMM yyyy', new Date()),
            };
        });
};
